import Axios from 'axios'
import config from '../app.config'

export var receiveTelephoneService
export default receiveTelephoneService = {
	getReceiveTelephones,
	createOrUpdateReceiveTelephone,
	deleteReceiveTelephone,
	updateReceiveTelephone,
	getReceiveTelephone,
	createOrUpdateCustomer
}

async function getReceiveTelephones({ ...queries }) {
	return await Axios.get(`${config.LOCAL_API_URL}/receive-telephone`, { params: queries })
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}

async function createOrUpdateReceiveTelephone(data) {
	return await Axios.post(`${config.LOCAL_API_URL}/receive-telephone`, data)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}

async function getReceiveTelephone(id) {
	return await Axios.get(`${config.LOCAL_API_URL}/receive-telephone/${id}`)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}

async function updateReceiveTelephone({ telephoneId, receiveTelephoneId, ...data }) {
	return await Axios.update(`${config.LOCAL_API_URL}/receive-telephone/${telephoneId}/receive/${receiveTelephoneId}`, data)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}

async function deleteReceiveTelephone(id) {
	return await Axios.delete(`${config.LOCAL_API_URL}/receive-telephone/${id}`)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}

async function createOrUpdateCustomer(data) {
	return await Axios.post(`${config.LOCAL_API_URL}/receive-telephone/customer`, data)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
